import { DemoFan, demoFans as GlobalDemoFans } from './datas/demoFan';
//import { demoFans as IndianDemoFans } from './datas/demoFanIndia';
import { demoFans as MexicoDemoFans } from './datas/demoFanMexico';
import { stationCompanions } from './datas/stationCompanions';

// Environment detection
const isDev = import.meta.env.MODE === 'development';
const useDemoFanMexico =
  import.meta.env.VITE_USE_DEMO_FAN_MEXICO !== undefined
    ? import.meta.env.VITE_USE_DEMO_FAN_MEXICO === 'true'
    : false;
const enable50PercentSignupModal = import.meta.env
  .VITE_ENABLE_50_PERCENT_SIGNUP_MODAL;
const baseDemoFans = useDemoFanMexico ? MexicoDemoFans : GlobalDemoFans;

// Feature Flags - Enable/disable features based on environment
export const Features = {
  enableLeaderboard: false,
  enableIndianMusic: false,
  enableFeaturedVideoCard: false,
  footerCarouselData: baseDemoFans,
  stationCompanions: isDev
    ? [...baseDemoFans, ...stationCompanions]
    : stationCompanions,
  enableOrganizationManagement: true,
  enableSingleSongMode: false,
  enableParallaxCarousel: false,
  enableCorrectMeButton: false,
};

/**
 * Get fan companions based on station mode
 * @param isStationMode - Whether station mode is enabled
 * @returns Array of companions including station companions if enabled
 */
export const getFanCompanions = (isStationMode: boolean): DemoFan[] => {
  const baseCompanions = Features.footerCarouselData;
  return isStationMode
    ? [...baseCompanions, ...Features.stationCompanions]
    : baseCompanions;
};

export const Config = {
  ENABLE_50_PERCENT_SIGNUP_MODAL: enable50PercentSignupModal === 'true',
};

export const placeHolderData = {
  contributorDesktopVideo:
    'https://demoassets.touchcast.com/napster-music/placeholder/napster_cat_landscape.mp4',
  contributorMobileVideo:
    'https://demoassets.touchcast.com/napster-music/placeholder/napster_cat_portrait.mp4',
  contributorThumbnail:
    'https://demoassets.touchcast.com/napster-music/placeholder/napster_cat.png',
  albumCover:
    'https://demoassets.touchcast.com/napster-music/placeholder/napster_cat.png',
};
export const nyxId = '73d9cac0-21a2-4e14-9762-58ccb4e93ee0';
export const helpCenterUrl = 'https://help.napster.com/hc/en-us';
export const userGenerationPromptKey = 'userGenerationPrompt';
